<template>
    <v-row justify="center">
        <v-dialog v-model="delete_quote_dialog" max-width="460px" persistent>
            <v-card class="leads-dialog-card">
                <div class="leads-dialog-header pa-5">
                    <div class="d-flex align-center justify-space-between">
                        <div class="leads-dialog-title">
                            <v-icon class="mr-2" color="white" size="20">mdi-delete-outline</v-icon>
                            Delete Quote
                        </div>
                        <v-btn icon dark @click="closeDeleteQuoteDialog()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </div>
                <v-card-text class="pa-6">
                    <p style="font-family:Manrope;font-size:14px;color:#3D3D3D;">Are you sure you want to delete this quote? Any data attached to this quote will be deleted.</p>
                    <v-text-field v-model="confirmation" outlined dense placeholder="Type DELETE to confirm" hide-details></v-text-field>
                    <QuoteDeleteImpact :quote_id="quote_id" :active="delete_quote_dialog" @blocked="setBlocked" />
                </v-card-text>
                <v-divider />
                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn text class="leads-btn" @click="closeDeleteQuoteDialog()">Cancel</v-btn>
                    <v-btn depressed dark color="error" class="leads-btn" @click="deleteQuote()" :disabled="confirmation != 'DELETE' || blocked">
                        <v-icon small left>mdi-delete</v-icon>
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import QuoteDeleteImpact from '../../quotes/components/QuoteDeleteImpact.vue'

export default {
    components: { QuoteDeleteImpact },
    data: () => ({
        confirmation: null,
        blocked: false,
    }),
    props: [
        'delete_quote_dialog', 'quote_id'
    ],
    methods: {
        setBlocked(value) {
            this.blocked = value
        },
        closeDeleteQuoteDialog() {
            this.$emit('closeDeleteQuoteDialog')
            this.confirmation = null
        },
        deleteQuote() {
            this.$emit('deleteQuote')
            this.confirmation = null
        }
    },
}

</script>

<style lang="scss" scoped>
.leads-dialog-card {
    border-radius: 12px !important;
    overflow: hidden;
}

.leads-dialog-header {
    background: linear-gradient(135deg, #3988AA 0%, #2a6a88 100%);
}

.leads-dialog-title {
    font-family: Manrope;
    font-size: 18px;
    font-weight: 700;
    color: white;
    display: flex;
    align-items: center;
}

.leads-btn {
    font-family: Manrope;
    font-weight: 600 !important;
    font-size: 13px !important;
    text-transform: none;
}
</style>